import type { DownloadInformation } from '@egr/xbox/share/processor/ShareContentOWDSUploadProcessor';

import { t } from 'i18next';

import { owdsValidUntil } from '@egr/xbox/eaiws-plugins/utils';

export function getShareLabel(value: DownloadInformation): string {
    switch (value.formatKey) {
        case 'snapshot':
            return t('Current view ({{type}})', { type: 'PNG' });
        case 'jpg':
            return t('Current view ({{type}})', { type: 'JPG'});
        case 'articlelist':
            return t('Article list ({{type}})', { type: 'PDF'});
        case 'modelList':
            return t('Model list ({{type}})', { type: 'PDF'});
        case 'modelListExcel':
            return t('Model list ({{type}})', { type: 'Excel'});
        case 'excel':
            return t('Article list ({{type}})', { type: 'Excel'});
        case 'FBX':
        case '3DS':
        case 'DWG':
        case 'RVT':
            return t('Articles ({{type}})', {type: value.formatKey});
        case 'gallery':
            return t('Images from gallery (PNG/JPG)');
        case 'GLB':
            return t('AR: Articles ({{type}})', { type: t('for Android GLB') });
        case 'USDZ':
            return t('AR: Articles ({{type}})', { type: t('for iOS USDZ')});
        case 'USDZwithWalls':
            return t('AR: Scene ({{type}})', { type: t('for iOS USDZ')});
        case 'OBK':
            return t('pCon Project ({{type}})', { type: 'OBK' });
        case 'OBX':
            return t('pCon Article list ({{type}})', { type: 'OBX'});
        case 'planningUrl':
            return t('Link to the planning');
        default:
            return value.filetype.extension.toLocaleUpperCase();
    }
}

export function prettyMailSubContent(previous: string, current: DownloadInformation): string {
    return `${previous}\r\n${getShareLabel(current)}: ${current.url} (${owdsValidUntil(current.expirationTimestamp)})\r\n`;
}

/**
 * language can not be used atm,
 * because of bug if cookie-banner appears the site redirects to english
 */
export function getRevitPluginUrl(_: string) {
    return 'https://pcon-solutions.com/download-area/';
}